<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-ellipsis-h</v-icon>
        <span class="m-l-5">Pause for</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>
    <div class="d-flex top-5 align-center no-drag">
      <v-slider
        v-model="prompt.value"
        class="boost-scroll"
        :max="5"
        :min="0.1"
        :step="0.1"
        hide-details
      ></v-slider>
      <span class="m-l-10"> {{ prompt.value }} seconds </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayloadPause',
  props: {
    index: Number,
    prompt: Object
  },
  methods: {
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.boost-scroll {
  // height: 0px;
  // margin-bottom: 10px;
  margin-top: 3px;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}
</style>
